import React, { Component } from 'react';
import { withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import MenuIcon from '@material-ui/icons/Menu';
import CloseIcon from '@material-ui/icons/Close';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Hidden from '@material-ui/core/Hidden';
import Collapse from '@material-ui/core/Collapse';
import { withRouter, Link } from 'react-router-dom';

import MobileMenu from './NavMobileMenu';
import AsyncentricLogo from '../../images/asyncentric.png';

const styles = {
    root: {
        flexGrow: 1,
        letterSpacing: '1px'
    },
    grow: {
        flexGrow: 1,
    },
    bannerContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    logoImage: {
        width: '26px',
        height: '26px',
        margin: '0 5px 0 0'
    },
    logoText: {
        color: '#030C54',
        fontSize: '22px',
        fontWeight: '700',
        cursor: 'pointer'
    },
    menuButton: {
        marginLeft: 0,
        marginRight: 0,
        color: '#222222'
    },
    menu: {
        marginLeft: 20,
        marginRight: 20,
        fontSize: '17px',
        color: '#222222',
        letterSpacing: '1px',
        textDecoration: "none",
        '&:hover': {
            color: "#e67300"
        }
    },
    mobileMenu: {
        transition: '1s'
    }
};

class Navbar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mobileNav: false
        }
    }


    mobileNavBarOpen = () => {
        this.setState((prevState) => {
            return {
                mobileNav: !prevState.mobileNav
            }
        });
    }

    render() {
        const { classes } = this.props;
        return (
            <div className={classes.root}>
                <AppBar position="static">
                    <Toolbar>
                        <div className={classes.grow}>
                            <div className={classes.bannerContainer}>
                                <img src={AsyncentricLogo} alt="Asyncentric Logo" className={classes.logoImage}></img>
                                <Typography variant="h5"><span className={classes.logoText} onClick={() => {
                                    this.props.history.push('/');
                                }}><b>𝐀𝐒𝐘𝐍𝐂𝐄𝐍𝐓𝐑𝐈𝐂</b></span></Typography>
                            </div>
                        </div>
                        <Hidden only={['xl', 'lg', 'md', 'sm']}>
                            {this.state.mobileNav ? <IconButton className={classes.menuButton} color="inherit" aria-label="Menu" onClick={this.mobileNavBarOpen}>
                                <CloseIcon />
                            </IconButton> : <IconButton className={classes.menuButton} color="inherit" aria-label="Menu" onClick={this.mobileNavBarOpen}>
                                    <MenuIcon />
                                </IconButton>}
                        </Hidden>
                        <Hidden only={['xs']}>
                            <Typography color="inherit"><Link to="/about" className={classes.menu}>About</Link></Typography>
                            <Typography color="inherit"><Link to="/portfolio" className={classes.menu}>Portfolio</Link></Typography>
                            <Typography color="inherit"><Link to="/blog" className={classes.menu}>Blog</Link></Typography>
                        </Hidden>
                    </Toolbar>
                    <Hidden only={['xl', 'lg', 'md', 'sm']}>
                        <Collapse in={this.state.mobileNav}>
                            <div className={classes.mobileMenu}><MobileMenu /></div>
                        </Collapse>
                    </Hidden>
                </AppBar>
            </div>
        );
    }
}

Navbar.propTypes = {
    classes: PropTypes.object.isRequired
}

export default withRouter(withStyles(styles)(Navbar));